import { ResetPasswordState } from './reset-password.models';

export const RESET_PASSWORD_FEATURE_KEY = 'resetPassword';

export const initialResetPasswordState: ResetPasswordState = {
  step: 'request',
  loading: false,
  tokenStatus: 'idle',
  submittedEmail: '',
  resetToken: null,
  resendAttempts: 0,
  resendRemainingSeconds: 0,
  error: null,
  retry: null,
  newPasswordCheck: 'idle',
};
